import React, { useContext, useEffect, useState } from 'react';

import LazyLoading from "../../components/LazyLoading";
import { Col, Form, Modal, Row } from "@themesberg/react-bootstrap";
import fetchWrapper from "../../utils/fetch/fetchWrapper";
import { BASE_URL } from "../../config";
import { LOCAL_STORAGE } from "../../context/LocalStorage";
import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import 'react-data-table-component-extensions/dist/index.css';
const ModalDetails = ({ showModal, setShowModal, id, setId }) => {

    const [dataOrder, setDataOrder] = useState({});
    const [data, setData] = useState([]);

    let token = localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN)

    useEffect(() => {
        fetchWrapper()
          .doPost({
              url: "/client_orders_find",
              body:{
                  id: id
              },
              onSuccess: async (response) => {
                  setDataOrder(response.data.orders)
                  setData(response.data)
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
        // axios({
        //     method: "post",
        //     url: BASE_URL + "/client_orders_find",
        //     headers: {
        //         'Authorization': token
        //     },
        //     data: {
        //         id: id,
        //     },
        //     timeout: 5000
        // })
        //     .then(function (response) {
        //         console.log(response.data);
        //         if ((response.data.status = 200)) {
        //             setDataOrder(response.data.orders)
        //             setData(response.data)
        //         }
        //     })

        //     .catch(function (error) {
        //         console.log(error);
        //     });
    }, [showModal]);

    const handleClose = () => {
        setShowModal(false);
        setId(null)
    }
    const columns = [
        {
            name: "Email",
            selector: "email",
            sortable: true,
        },
        {
            name: "Nombre",
            selector: "first_name",
            sortable: true,
        },
        {
            name: "Apellido",
            selector: "last_name",
            sortable: true,
        },
        {
            name: "Genero",
            selector: "gender",
            sortable: true,
        },
        {
            name: "Código",
            selector: "invitation_code",
            sortable: true,
        },
    ];
    const columnItem = [
        {
            name: "Dirección",
            selector: "address",
            sortable: true,
            wrap: true,
            grow: 3
        },
        {
            name: "Total",
            selector: "total",
            sortable: true,
        },
        {
            name: "SubTotal",
            selector: "subtotal",
            sortable: true,
        },
        {
            name: "Despacho",
            selector: "dispatch_price",
            sortable: true,
        },
        {
            name: "Descuento",
            selector: "discount",
            sortable: true,
        },
        {
            name: "Estado",
            selector: "state",
            sortable: true,
            wrap: true,
            grow: 2
        },
        {
            name: "Cliente",
            selector: "client",
            sortable: true,
            wrap: true,
        },
        {
            name: "Cleaner",
            selector: "employee",
            sortable: true,
            wrap: true,
        },
        {
            name: "Rut del Cleaner",
            selector: "employee_rut",
            sortable: true,
            wrap: true,
            grow: 1
        },
        {
            name: "Ganancias Cleaner",
            selector: "cleaner_profits",
            sortable: true,
        },
        {
            name: "Ganancias Seifrei",
            selector: "seifrei_profits",
            sortable: true,
        },
    ];
    return (
        <Modal show={showModal} onHide={() => handleClose()}

            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Detalles del Cliente
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div >
                    <h4>Cliente: </h4>
                    <DataTable
                        columns={columns}
                        data={data}
                    />
                </div>
                <div className="row mt-5 ">
                    <h4>Ordenes del cliente:</h4>
                </div>
                <DataTable
                    columns={columnItem}
                    data={dataOrder}
                    pagination
                    noHeader
                    paginationPerPage={10}
                />
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-light" onClick={() => handleClose()}>Cerrar</button>
            </Modal.Footer>
        </Modal>


    );
};

export default ModalDetails
